import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { CITY_MALL_CARD_PAGE_PATH } from "utils/constants/paths";

const CityMallCardPage = Loadable(React.lazy(() => import("./View")));

export const CityMallCardPageRoute: IRouteItem = {
  path: CITY_MALL_CARD_PAGE_PATH,
  element: React.createElement(CityMallCardPage),
  name: "City Mall Card",
};
